import { useFormContext } from "react-hook-form"
import { useState } from "react"
import { Button, TableBody, TableCell, TableRow, Table, TableContainer, TableHead, IconButton } from "@mui/material"
import AddIcon from '@mui/icons-material/Add';
import { Box, Typography } from "@mui/material"
import DeleteIcon from '@mui/icons-material/Delete';
import DialogAdicionar, { ProdutoSelecionado } from "./DialogAdicionar";
import EditIcon from '@mui/icons-material/Edit';

export default function DisplayIncluirNaoSugeridos() {

    const { setValue, watch, getValues } = useFormContext()
    const valueNaoSugeridos = watch('nao_sugeridos')

    const [openModal, setOpenModal] = useState<boolean>(false)

    //funções manipuladoras
    const handleRemoveItem = (index: number) => {
        const valorProdutos = getValues('nao_sugeridos')
        valorProdutos.splice(index, 1);
        setValue('nao_sugeridos', valorProdutos)
    }
    //

    return (
        <Box mb={1}>
            {
                (valueNaoSugeridos.length <= 0) && (
                    <Box
                        gap={0.5}
                        display="flex"
                        alignItems="center"
                        flexDirection="column"
                        justifyContent="center"
                        borderRadius={1}
                        height={125}
                        border="1px solid #1B5E20"
                    >
                        <Typography variant="subtitle2">Clique no botão abaixo para adicionar os itens não sugeridos</Typography>
                        <Button size="small" variant="contained" startIcon={<AddIcon />} onClick={() => setOpenModal(true)}>
                            Adicionar
                        </Button>
                    </Box>
                )
            }

            {
                (valueNaoSugeridos.length > 0) &&
                <>
                    <Box mb={1} display="flex" alignItems="center" justifyContent="space-between">
                        <Typography variant="h6">Itens adicionais não sugeridos</Typography>

                        <Button size="small" variant="contained" startIcon={<EditIcon />} onClick={() => setOpenModal(true)}>
                            Editar
                        </Button>
                    </Box>

                    <TableContainer sx={{ border: "1px solid #ccc", borderRadius: 2 }}>
                        <Table size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell><b>Produto</b></TableCell>
                                    <TableCell align="right"><b>Qtd. Origem</b></TableCell>
                                    <TableCell align="right"><b>Solicitado</b></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {
                                    valueNaoSugeridos.map((item: ProdutoSelecionado, index: number) => {
                                        return (
                                            <TableRow
                                                key={index}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {`${item.codigo} - ${item.nome}`}
                                                </TableCell>

                                                <TableCell align="right">
                                                    {item.estoque_origem}
                                                </TableCell>
                                                
                                                <TableCell align="right">
                                                    {item.quantidade}
                                                </TableCell>

                                                <TableCell align="right">
                                                    <Box display="flex" gap={0.5} justifyContent="flex-end">
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            color="error"
                                                            onClick={() => handleRemoveItem(index)}
                                                        >
                                                            <DeleteIcon fontSize="inherit" />
                                                        </IconButton>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            }

            {
                openModal && (
                    <DialogAdicionar
                        open={openModal}
                        handleClose={() => setOpenModal(false)}
                    />
                )
            }
        </Box>
    )
}